import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import pdfile from '@/api/pdf'
import { usePdftStore } from '@/store/pdf'

export const downloadPDF = (page) => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    html2canvas((page), {
        useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
    }).then(function(canvas) {
        canvas2PDF(canvas);
    });

}

const canvas2PDF = (canvas) => {
    var contentWidth = canvas.width
    var contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
    var pageHeight = contentWidth / 592.28 * 841.89
        // 未生成pdf的html页面高度
    var leftHeight = contentHeight
        // pdf页面偏移
    var position = 0
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28
    var imgHeight = 592.28 / contentWidth * contentHeight
    var pageData = canvas.toDataURL('image/jpeg', 1.0)

    // eslint-disable-next-line
    var pdf = new jsPDF('p', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
        while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
                // 避免添加空白页
            if (leftHeight > 0) {
                pdf.addPage()
            }
        }
    }
    // 导出pdf文件命名
    pdf.save('report_pdf_' + new Date().getTime() + '.pdf')
    var pdfFile = pdf.output('datauristring') //获取base64Pdf
    const PdftStore = usePdftStore()
    let file = dataURLtoBlob(pdfFile)
    PdftStore.postFile(file)
};

// 将base64转成blob 为了后续能上传
const dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(',')
        //注意base64的最后面中括号和引号是不转译的
    var _arr = arr[1].substring(0, arr[1].length - 2)
    var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], {
        type: mime
    })
};